"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCatTag = getCatTag;

var _request = _interopRequireDefault(require("@/utils/request"));

function getCatTag(id) {
  return (0, _request.default)({
    url: "/cat-tags/".concat(id),
    method: 'get'
  });
}